<template>
    <div class="slider">
        <common-icon v-if="icon" class="slider__icon-left" :name="icon" size="large"></common-icon>
        <input type="range" :min="min" :max="max" :value="value" :step="step" :disabled="isDisabled" @input="change" />
        <common-icon v-if="icon" class="slider__icon-right" :name="icon" size="extra-huge"></common-icon>
    </div>
</template>

<script>
    export default {
        props: {
            icon: { type: String, default: null },
            min: { type: Number, default: 0 },
            max: { type: Number, default: 100 },
            value: { type: Number, default: 0 },
            step: { type: Number, default: 1 },
            isDisabled: { type: Boolean, default: false },
        },

        methods: {
            starClass(index) {
                return {
                    'rating-stars__star': true,
                    'rating-stars__star--on': index <= this.rating,
                }
            },

            change(event) {
                this.emitEvent({ name: 'change', payload: { value: event.target.value } })
            },
        },
    }
</script>
